export enum BrandSelectorTestIds {
  TRIGGER_BUTTON = 'brand-selector-trigger-button',
  BRAND_ITEM_PREFIX = 'brand-selector-brand-item-',
}
